import { Component, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Contact } from '../../model/account.model';

@Component({
  selector: 'jhi-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ContactComponent {

  @Input()
  contact: Contact;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/contact/contact.component.ts